var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAssetVersionloader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 276,
    height: 341,
    viewBox: "0 0 276 341",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9112_17097)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 304.75,
    width: 276,
    height: 14,
    rx: 7,
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 326.75,
    width: 109,
    height: 14,
    rx: 7,
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 274.75,
    width: 217,
    height: 14,
    rx: 7,
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 0.75,
    width: 276,
    height: 258,
    rx: 8,
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_9112_17097)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.75,
    width: 276,
    height: 138,
    fill: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154 49.75L196 105.75H112L154 49.75Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.5 69.75L133 105.75H80L106.5 69.75Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 119.5,
    cy: 46.25,
    r: 11.5,
    fill: "#F5F5F5"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 154.75,
    width: 244,
    height: 14,
    rx: 7,
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 176.75,
    width: 244,
    height: 14,
    rx: 7,
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 206.75,
    width: 175,
    height: 14,
    rx: 7,
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 228.75,
    width: 146,
    height: 14,
    rx: 7,
    fill: "#E0E0E0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9112_17097"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 276,
    height: 340,
    fill: "white",
    transform: "translate(0 0.75)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_9112_17097"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 8.75C0 4.33172 3.58172 0.75 8 0.75H268C272.418 0.75 276 4.33172 276 8.75V138.75H0V8.75Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssetVersionloader);
export default __webpack_public_path__ + "static/media/assetVersionloader.19d0c874.svg";
export { ForwardRef as ReactComponent };